import styled from "styled-components";

import { colorsPalettes, truncateText } from "@similarweb/styles";
import { ItemIcon } from "@similarweb/ui-components";

import { SharedSearchInputStyles } from "app/pages/sales-intelligence/pages/company-analysis/styles";

export const StyledCompetitorsTableWrapper = styled.div`
    border-top: 1px solid ${colorsPalettes.carbon["100"]};
    .ant-table-header {
        top: 48px !important;
    }
`;

export const StyledCompetitorsSearchContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 16px 8px 0;
    height: 39px;

    .SearchInput-container {
        flex-grow: 1;

        .SearchInput {
            height: 34px;
            ${SharedSearchInputStyles}
        }
    }
`;

export const StyledItemIcon = styled(ItemIcon)`
    flex: none;
`;

export const StyledCompanyName = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    span {
        ${truncateText()};
    }
`;
